export function meta(pageTitle) {
  document.title = pageTitle;
}